import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EtiquetaMascarello } from 'src/app/_models/etiqueta-mascarello';

@Component({
  selector: 'app-modal-etiqueta-mascarello',
  templateUrl: './modal-etiqueta-mascarello.component.html',
  styleUrls: ['./modal-etiqueta-mascarello.component.scss']
})
export class ModalEtiquetaMascarelloComponent implements OnChanges {

  @Input()
  etiqueta: EtiquetaMascarello | null = null;

  @Input()
  larguraDaEtiqueta: number | null = null;

  @Input()
  alturaDaEtiqueta: number | null = null;

  @Output()
  btnFecharClicked = new EventEmitter<void>();

  @ViewChild('modal')
  modal: ModalDirective | null = null;

  @ViewChild('etiquetaElm', { read: ElementRef })
  etiquetaRef: ElementRef | null = null;

  etiquetaParaPdf: HTMLElement | null = null;

  constructor () { }

  ngOnChanges (changes: SimpleChanges) {

    if (changes['etiqueta'])
      this.onEtiquetaChange();
  }

  private onEtiquetaChange () {

    if (this.etiqueta)
      this.mostrarModal();
    else
      this.esconderModal();
  }

  private mostrarModal () {

    this.modal!.show();

    this.etiquetaParaPdf = this.etiquetaRef!.nativeElement;
  }

  private esconderModal () {

    this.modal?.hide();

    this.etiquetaParaPdf = null;
  }

  onBtnFecharClick () {

    this.btnFecharClicked.emit();
  }

  onBtnSalvarClick () {

    const width = 1070;
    const height = 680;
    const left = Math.round((window.screen.width - width) / 2);
    const top = Math.round((window.screen.height - height) / 2);
    const popupWin = window.open('', '_blank', `width=${ width },height=${ height },top=${ top },left=${ left }`);

    if (!popupWin) {
      return;
    }

    popupWin.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>
            Etiqueta
          </title>
          <style>
            *, *::before, *::after {
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
            }
            html, body {
              width: 100%;
              height: 100%;
            }
            body {
              visibility: hidden;
              margin: 0;
              padding: 0;
              font-family:
                -apple-system,
                BlinkMacSystemFont,
                "Segoe UI",
                Roboto,
                "Helvetica Neue",
                Arial,
                sans-serif,
                "Apple Color Emoji",
                "Segoe UI Emoji",
                "Segoe UI Symbol";
              font-size: 0.875rem;
              font-weight: 400;
              line-height: 1.5;
              color: #151b1e;
              text-align: left;
              background-color: #f2f4f8;
            }
            @media print {
              @page {
                size: ${ this.larguraDaEtiqueta }px ${ this.alturaDaEtiqueta }px;
                margin: 0;
                padding: 0;
              }
              body {
                visibility: visible;
              }
            }
          </style>
          <link rel="stylesheet" type="text/css" href="assets/css/etiqueta-mascarello.css" />
        </head>
        <body onload="window.print(); window.close();">
          ${ this.etiquetaParaPdf!.outerHTML }
        </body>
      </html>
    `);

    popupWin.document.close();
    popupWin.focus();
  }
}
